import { render, staticRenderFns } from "./UserBlock.vue?vue&type=template&id=871c1b30&scoped=true"
import script from "./UserBlock.vue?vue&type=script&lang=ts"
export * from "./UserBlock.vue?vue&type=script&lang=ts"
import style0 from "./UserBlock.vue?vue&type=style&index=0&id=871c1b30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871c1b30",
  null
  
)

export default component.exports